<template>
  <h1>SERVICES</h1>
</template>

<script setup></script>

<style lang="scss" scoped></style>
